// extracted by mini-css-extract-plugin
export var measureBox = "_ac-0";